import { FILE_TYPES } from '@shared/constants';

import { getMimeTypesForFileType } from './file-types';

/**
 * Escapes every regular-expression metacharacter in a raw string so it can
 * be embedded in a `RegExp` / Mongo `$regex` as a literal. Without this,
 * user-supplied search input like `a(b` throws (unbalanced group) and
 * input like `.*` behaves as a wildcard - both undesirable when the value
 * is meant to be matched verbatim.
 */
export function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export function getURLRegex(webDomain: string): RegExp {
  return new RegExp(
    `(http(s)?:\\/\\/)?(www\\.)?(${webDomain})\\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*)`
  );
}

export function getNavigationRegex(webDomain: string): RegExp {
  return new RegExp(`(http(s)?:\\/\\/)?(www\\.)?(${webDomain})`);
}

export function generateFileTypeRegex(types: FILE_TYPES[]): RegExp {
  const allowedMimeTypes = types.flatMap((type) =>
    getMimeTypesForFileType(type)
  );

  return new RegExp(allowedMimeTypes.join('|'));
}
